import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translateColumns, { translateSort } from '../dataTable/dataTranslate';
import DataTable from '../dataTable';

const AuditSubTable = ({ displayData }) => {
  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'TransactionID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'ChangeTimeStamp',
      text: 'Date',
      hidden: true,
    },
    {
      dataField: 'Transactiontype',
      text: 'Type',
      hidden: true,
    },
    {
      dataField: 'RealUser',
      text: 'Changed By',
      hidden: true,
    },
    {
      dataField: 'ImpersonatedUser',
      text: 'Impersonating',
      hidden: true,
    },
    {
      dataField: 'RecordUniqueID',
      text: 'ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '10%' },
    },
    {
      dataField: 'ClassName',
      text: 'Field Type',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '15%' },
    },
    {
      dataField: 'FieldName',
      text: 'Field Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
    },
    {
      dataField: 'OldValue',
      text: 'Changed From',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
      classes: 'text-danger',
    },
    {
      dataField: 'NewValue',
      text: 'Changed To',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      headerStyle: { width: '25%' },
      classes: 'text-success',
    },
  ];

  const defaultSorted = [{
    dataField: 'RecordUniqueID',
    order: 'desc',
  }];

  const newCols = useMemo(() => translateColumns(columns), [columns]);

  return (
    <DataTable
      defaultSorted={translateSort(defaultSorted)}
      columns={newCols}
      sizePerPage={9999}
      data={displayData}
      wrapperClasses="table-responsive"
      id="officesTable"
      noDataIndication="No Data Returned."
      classes="dataTable subtable"
      striped
      hover
    />
  );
};

AuditSubTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AuditSubTable;
